import styled from 'styled-components';

import { breakpoint } from '../../utils/breakpoint';
import { FONT_WEIGHT, fonts } from '../Common';

interface ISponsorLogoWrapper {
  $visibility: boolean;
}

export const SponsorLogoWrapper = styled.div<ISponsorLogoWrapper>`
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  justify-content: space-evenly;
  align-items: center;
  visibility: ${(props) => (props.$visibility ? 'visible' : 'hidden')};
  margin-top: 0.625rem;
`;

export const SponsorLogoLabel = styled.div`
  color: ${({ theme }) => theme.colors['pure-white']};
  font-family: 'GothamNarrow';
  font-weight: ${FONT_WEIGHT.Regular};
  text-align: center;
  margin-bottom: 0.5rem;
  font-size: 0.875rem;
  line-height: 1.125rem;

  ${breakpoint('lg')`
    margin-bottom: 0.75rem;
    ${fonts.title.xs};
  `}
`;
export const SponsorLogoImg = styled.img`
  width: 7.5rem;

  ${breakpoint('lg')`
    width: 9rem;
  `}
`;
